import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "../../index.css";
import "./table.css";
import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Column } from "primereact/column";
import { useDispatch, useSelector } from "react-redux";
import { InputText } from "primereact/inputtext";
import { RenderDataTemplate } from "../dataTemplate/dataTemplate";
import { IconTypes, RenderIcons } from "./icons";
import { getDataList, setListingData } from "../../store/listing/listingSlice";
import { AppToast } from "../../lib/toast";
import { ComponentLoader } from "../loader/componentLoader";
import { getConfiguredLabel, jsonFromBase64 } from "../../common/commonHelper";
import {
  documents,
  DocumentsPage,
  keywordSearchMsg,
  recent,
  showing,
  showMsgPagination,
  sortIcon,
  svg,
  sortByMsg,
  deleteTitle,
  noRecordsMessage,
  results,
  home,
  HomePage,
  files,
  actions,
  selectedText,
} from "../../common/labelConstants";

const _props = {
  dataType_id: "",
  onInit: () => {},
  multipleDelete: false,
  templateName: "",
  _action: { width: "", RenderAction: () => {} },
  renderHeaderAreaRight: ({
    btn_download = <></>,
    btn_delete = <></>,
    filter_global = <></>,
    orderBy_icon = <></>,
    sortBy_dropdown = <></>,
    selectedRows = [],
    setSelectedRows = (rows = []) => {},
    add_item = (btnJsx = <></>) => {
      return <></>;
    },
  }) => {
    return <></>;
  },
  renderHeaderAreaLeft: ({ pagingInfo = <></>, specialInfo = <></> }) => {},
  handleAddNewItem: () => {},
  handleMultipleDelete: (rows) => {},
  fields: [],
};

let useGlobalFilter = false;
const orderHeader = {
  0: "(A to Z)",
  1: "(Z to A)",
};
const sizeOrderHeader = {
  0: "(Smallest First)",
  1: "(Largest First)",
};
const dateOrderHeader = {
  0: "(Oldest First)",
  1: "(Newest First)",
};
const ascDesOrder = {
  0: true,
  1: false,
};

const generateSortFileds = (header, field) => {
  const res = [];

  for (let i = 0; i < 2; i++) {
    if (header === "Size") {
      res.push({
        header: `${header} ${sizeOrderHeader[i]}`,
        field: field,
        order: ascDesOrder[i],
      });
    } else if (header === "Uploaded On") {
      res.push({
        header: `${header} ${dateOrderHeader[i]}`,
        field: field,
        order: ascDesOrder[i],
      });
    } else {
      res.push({
        header: `${header} ${orderHeader[i]}`,
        field: field,
        order: ascDesOrder[i],
      });
    }
  }
  return res;
};
const RenderPagination = {
  layout:
    "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
  RowsPerPageDropdown: (options) => {
    return (
      <React.Fragment>
        <span className="sort_group DisFlex paging_dropdown">
          <span className="sorting_area ">
            <span className="sortIncreseIcon"></span>{" "}
            {getConfiguredLabel(DocumentsPage, showMsgPagination)}{" "}
          </span>
          <Dropdown
            value={options.value}
            appendTo="self"
            options={options.options}
            onChange={(e) => {
              if (e?.originalEvent?.type !== "keydown") options.onChange(e);
            }}
          />
        </span>
      </React.Fragment>
    );
  },
};

const Table = (props = _props) => {
  let viewFields = props.fields
    ?.filter((x) => x.view && x.view.enabled)
    .map((x) => {
      return { ...x.view, field: x.field, dataType: x.dataType };
    });

  const viewFields_metadata = props.fields
    .filter((x) => x.name == "metadata")
    .map((m) =>
      m.fields
        .filter((x) => x.view && x.view.enabled)
        .map((x) => {
          return { ...x.view, field: x.field, dataType: x.dataType };
        })
    )
    .flatMap((e) => e.filter((f) => f !== undefined));

  if (Array.isArray(viewFields_metadata) && viewFields_metadata.length > 0) {
    viewFields_metadata.map((val) => {
      viewFields.push(val);
    });
  }

  viewFields.sort((a, b) => {
    return a.sequenceNumber - b.sequenceNumber;
  });

  let _sort_fields = [];
  const sortColumns = viewFields
    .filter((item) => item.sort && item.sort.enabled)
    .map((item) => {
      // sort options set asc, desc
      if (item.template && item.template == "metadata_tag") {
        _sort_fields.push(
          ...generateSortFileds(item.sort.name, "metadata." + item.field)
        );
        return { header: item.sort.name, field: "metadata." + item.field };
      } else {
        _sort_fields.push(...generateSortFileds(item.sort.name, item.field));
        return { header: item.sort.name, field: item.field };
      }
    });
  const defaultSortOption = {
    header: "Recent",
    field: "lastUpdated",
    order: 0,
  };
  _sort_fields.unshift(defaultSortOption);

  const [selectedRows, setSelectedRows] = useState([]);
  const [isMounted, setIsMounted] = useState(true);
  const [orderBy, setOrderBy] = useState(false);
  const [sortBy, setSortBy] = useState(defaultSortOption);
  const [rowsData, setRowsData] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [handleOnclick, setHandleOnclick] = useState();
  const [isPageChanged, setIsPageChanged] = useState(false);
  const slbSearchConfig = window.slbConfig || {};
  const dispatch = useDispatch();
  const fieldsFilter = useSelector((state) => state.list.dataFilter);
  const actionColumn =
    (viewFields || []).find((column) => column.dataType == "action") || {};
  const dataColumns =
    (viewFields || []).filter((column) => column.dataType != "action") || {};

  const fieldsForFilter = {};
  dataColumns.map((x) => {
    if (x.filterable) {
      fieldsForFilter[x.field] = { value: "" };
    }
  });
  useEffect(() => {
    setLazyParams((val) => {
      return {
        ...val,
        rows: props.defaultPageSize,
      };
    });
  }, [props.rowsPerPageOptions]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 0,
    page: 0,
    sortField: "lastUpdated",
    sortOrder: 0,
    filters: {
      global: "",
      // ...fieldsForFilter,
      fields: [],
    },
    dataType_id: props.dataType_id,
    templateName: props.templateName,
    clientId: slbSearchConfig.accountId,
    metadataField: [],
  });
  const refreshTable = () => {
    setLazyParams((val) => {
      return { ...val };
    });
  };

  const [toggleClassName, setToggleClassName] = useState(false);

  const handleOnKeyUp = (e) => {
    const value = e?.target.value;
    useGlobalFilter = true;
    setLazyParams((val) => {
      val.page = 0;
      val.first = 0;
      val.filters.global = value;
      return { ...val };
    });
  };

  const handleFieldFilter = (e, fieldName, b) => {
    const fields = fieldsFilter?.fields || [];
    const fields_filtered = fields.filter((x) => x.name != fieldName);
    dispatch(
      setListingData({
        fields: [
          ...fields_filtered,
          { name: fieldName, value: e.target.value },
        ],
        template: props.templateName,
      })
    );
  };

  const renderHeader = () => {
    const showResults = (
      <div className="rc_shwoingdata_wrapper">
        <div className="showingData">
          <span className="showingHead">
            {getConfiguredLabel(DocumentsPage, showing)}
          </span>
        </div>
        <div className="showingData showingDataLength">
          <strong>
            {lazyParams.first > 0
              ? lazyParams.first + 1
              : totalRecords / (lazyParams.rows * (lazyParams.page + 1)) > 0
              ? lazyParams.page + 1
              : 0}
          </strong>{" "}
          -{" "}
          <strong>
            {totalRecords <= lazyParams.rows * (lazyParams.page + 1)
              ? totalRecords
              : lazyParams.rows * (lazyParams.page + 1)}
          </strong>{" "}
          <span>of</span> <strong>{totalRecords}</strong>{" "}
          <span>{getConfiguredLabel(DocumentsPage, results)}</span>
        </div>
      </div>
    );

    const btn_download = (
      <>
        <span className="download_icon">{RenderIcons(IconTypes.Download)}</span>
      </>
    );

    const btn_delete = props.multipleDelete ? (
      <span
        className="delete_icon"
        onClick={() => {
          if (selectedRows.length < 1) {
            AppToast.Toast.warning({
              title: getConfiguredLabel(DocumentsPage, deleteTitle),
              message: getConfiguredLabel(DocumentsPage, noRecordsMessage),
            });
          } else {
            props.handleMultipleDelete(selectedRows, "Multiple");
          }
        }}
      >
        {RenderIcons(IconTypes.Delete)}
      </span>
    ) : null;
    const sortBy_dropdown = (
      <div>
        <span className="sort_group DisFlex">
          <span className="sorting_area">
            <span className="sortIncreseIcon">
              <span
                dangerouslySetInnerHTML={{
                  __html: getConfiguredLabel(svg, sortIcon),
                }}
              ></span>
            </span>{" "}
            {getConfiguredLabel(DocumentsPage, sortByMsg)}{" "}
          </span>
          <Dropdown
            appendTo="self"
            defaultValue={_sort_fields[0]}
            optionLabel="header"
            value={sortBy}
            options={_sort_fields}
            onChange={(e) => {
              // setLazyParams((state) => {
              //     return {
              //         ...state,
              //         sortField: e.target.value.field,
              //         sortOrder: e.target.value.order
              //     }
              // })
              setSortBy(e.target.value);
              setLazyParams((val) => {
                return {
                  ...val,
                  sortField: e.target.value.field,
                  sortOrder: e.target.value.order,
                  page: 0,
                  first: 0,
                };
              });
            }}
            // placeholder={getConfiguredLabel(DocumentsPage,recent)}
          />
        </span>
      </div>
    );

    const orderBy_icon = (
      <span
        onClick={() => {
          setLazyParams((v) => {
            return {
              ...v,
              sortOrder: !orderBy,
            };
          });

          setOrderBy((v) => {
            return (v = !v);
          });
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.162"
          height="24"
          viewBox="0 0 16.162 24"
        >
          <g id="sort" transform="translate(-85.084 0.248)">
            <g
              id="Group_157"
              data-name="Group 157"
              transform="translate(85.084 -0.248)"
            >
              <g id="Group_156" data-name="Group 156" transform="translate(0)">
                <path
                  id="Path_61"
                  data-name="Path 61"
                  d="M222.844,4.207,218.925.288h0q-.034-.034-.071-.064L218.819.2l-.042-.031L218.734.14l-.039-.023L218.65.1l-.042-.02L218.564.06l-.047-.016-.044-.011L218.424.02l-.052-.008-.043-.006a.986.986,0,0,0-.193,0l-.043.006-.052.008-.048.012-.045.011L217.9.06l-.044.016-.042.02-.044.021-.039.023-.043.026L217.647.2l-.035.026c-.025.02-.049.042-.071.064h0l-3.918,3.918a.98.98,0,1,0,1.385,1.385l2.246-2.246V14.7a.98.98,0,1,0,1.959,0V3.346l2.246,2.246a.98.98,0,1,0,1.385-1.385Z"
                  transform="translate(-207.213 0.243)"
                ></path>
                <path
                  id="Path_61_-_Outline"
                  data-name="Path 61 - Outline"
                  d="M218.228-.248c.04,0,.081,0,.121.006l.043.006.022,0,.053.009.05.012.021.005.045.012.048.016.019.007.045.017.044.02.018.009L218.8-.1l.04.023.019.011.044.027.044.032.017.013L219,.029c.03.024.058.05.086.077l0,0,3.918,3.918A1.224,1.224,0,1,1,221.28,5.76l-1.828-1.828V14.69a1.224,1.224,0,1,1-2.449,0V3.932L215.175,5.76a1.225,1.225,0,1,1-1.732-1.732L217.372.1c.025-.024.051-.048.079-.071L217.486,0l.018-.014.043-.031.043-.027.019-.011L217.65-.1l.046-.023.02-.009.043-.02.044-.017.02-.007.049-.017.046-.012.02-.005.05-.012.054-.009.021,0,.043-.006C218.147-.246,218.188-.248,218.228-.248Zm.512.7c-.015-.014-.03-.028-.046-.041L218.682.4l-.026-.02-.02-.015-.02-.012L218.59.337l-.016-.01-.021-.01-.025-.012L218.508.3,218.489.29l-.026-.009-.022-.008-.018,0-.03-.007-.022-.005-.025,0-.033,0-.013,0a.744.744,0,0,0-.145,0l-.014,0-.033,0-.024,0-.022.005-.029.007-.019,0-.022.008-.027.01L217.946.3l-.018.008L217.9.318l-.02.01-.016.01-.026.016-.019.011L217.8.379l-.028.02-.011.008c-.019.016-.037.032-.053.048l-.01.01L213.79,4.375a.735.735,0,0,0,1.039,1.039l2.664-2.664V14.69a.735.735,0,1,0,1.469,0V2.75l2.664,2.664a.735.735,0,1,0,1.039-1.039Z"
                  transform="translate(-207.208 0.248)"
                ></path>
                <path
                  id="Path_62"
                  data-name="Path 62"
                  d="M93.457,180.75,91.211,183V171.647a.98.98,0,0,0-1.959,0V183l-2.246-2.246a.98.98,0,0,0-1.385,1.385l3.918,3.918h0c.023.023.046.044.071.064l.035.026.042.031.043.026.039.023.045.021.042.02.044.016.047.016.044.011.048.012.052.008.043.006a.979.979,0,0,0,.193,0l.043-.006.052-.008.048-.012.044-.011.047-.016.044-.016.042-.02.045-.021.039-.023.043-.026.042-.031.035-.026q.037-.03.071-.064h0l3.918-3.918a.98.98,0,1,0-1.385-1.385Z"
                  transform="translate(-85.089 -162.585)"
                ></path>
                <path
                  id="Path_62_-_Outline"
                  data-name="Path 62 - Outline"
                  d="M90.227,186.58c-.04,0-.081,0-.121-.006l-.043-.006-.023,0-.053-.008-.05-.012-.021-.005-.045-.012-.048-.017-.018-.006-.046-.017-.044-.02-.02-.01-.045-.022-.041-.024-.018-.011-.044-.027-.044-.032-.018-.013-.035-.026c-.029-.024-.057-.049-.084-.075l-.005-.005L85.442,182.3a1.225,1.225,0,0,1,1.732-1.732L89,182.4V171.641a1.224,1.224,0,1,1,2.449,0V182.4l1.828-1.828a1.224,1.224,0,1,1,1.732,1.732l-3.926,3.926c-.026.025-.053.05-.082.074l-.035.027-.017.013-.044.032-.044.027-.019.011-.04.023-.046.023-.018.009-.044.02-.044.016-.02.007-.049.017-.046.012-.019,0-.051.012-.053.009-.022,0-.044.006C90.307,186.578,90.267,186.58,90.227,186.58Zm-.513-.7c.015.015.031.029.048.043l.011.008.027.02.02.014.019.012.026.015.017.01.02.01.026.012.019.009.021.008.025.009.022.008.019,0,.029.007.022.005.024,0,.034.005.013,0a.739.739,0,0,0,.146,0l.014,0,.033,0,.023,0,.023-.006.028-.007.019,0,.022-.008.027-.01.019-.007.018-.009.025-.012.021-.01.016-.01.026-.016.02-.012.019-.014.027-.02.012-.008c.019-.015.037-.032.053-.048l3.919-3.919a.735.735,0,1,0-1.039-1.039l-2.664,2.664V171.641a.735.735,0,0,0-1.469,0v11.941l-2.664-2.664a.735.735,0,1,0-1.039,1.039Z"
                  transform="translate(-85.084 -162.58)"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </span>
    );

    const filter_global = (
      <div className="search_group rc_table_search_group">
        <span
          className="search_icon"
          onClick={() => {
            handleOnKeyUp(handleOnclick), setToggleClassName(!toggleClassName);
          }}
        >
          <i className="pi pi-search" />
        </span>
        <span
          className={
            toggleClassName
              ? "search_input search_open"
              : "search_input search_close"
          }
        >
          <InputText
            value={globalFilterValue}
            className="rc_table_search"
            onKeyUp={async (e) => {
              setHandleOnclick(e);
              if (e.charCode === 13 || e.keyCode === 13) {
                handleOnKeyUp(handleOnclick);
              }
            }}
            onChange={(e) => {
              const value = e.target.value;
              setGlobalFilterValue(value);
            }}
            placeholder={getConfiguredLabel(DocumentsPage, keywordSearchMsg)}
          />
        </span>
      </div>
    );

    const add_item = (btnJsx = <></>) => (
      <>
        <span
          onClick={() => {
            props.handleAddNewItem();
          }}
          type="button"
        >
          {btnJsx}
        </span>
      </>
    );

    const selected_count_jsx = (
      <div className="showingCountData">
        <div className="showingData">
          <span className="showingHead">
            {getConfiguredLabel(DocumentsPage, selectedText)}
          </span>
        </div>
        <div className="showingData showingDataLength rc_new_selecteddatacounter">
          <strong>
            {" "}
            {Array.isArray(selectedRows) ? selectedRows.length : 0}
          </strong>      
        </div>
      </div>
    );
    const headerAreaLeft =
      typeof props.renderHeaderAreaLeft === "function" ? (
        <>
          {filter_global}
          {selected_count_jsx}
        </>
      ) : (
        <></>
      );

    const headerAreaRight =
      typeof props.renderHeaderAreaRight === "function" ? (
        <>         
          {props.renderHeaderAreaLeft({ pagingInfo: showResults })}{" "}
          {sortBy_dropdown}
          {props.renderHeaderAreaRight({
            btn_delete,
            btn_download,
            orderBy_icon,
            setSelectedRows,
            selectedRows: selectedRows,
            add_item,
          })}
        </>
      ) : (
        <></>
      );

    return (
      <div className="document_header flex justify-content-between align-items-center">
        <div className="list_left_group rc_list_left">
          {headerAreaLeft}
          {/* {leftHeader} */}
        </div>
        <div className="list_right_group rc_list_right">
          {/* <span className='table_header_icon'>
                        <span className='download_icon'>
                            {RenderIcons("download")}
                        </span>
                    </span> */}
          {headerAreaRight}
        </div>
      </div>
    );
  };

  const header = renderHeader();
  function getRecords(listInfo) {
    setRowsData([]);
    dispatch(getDataList(listInfo)).then((res) => {
      if (isMounted && res?.payload?.status === 200) {
        setTotalRecords(res.payload?.data.totalRecords);
        let data = res?.payload?.data?.data;
        if (typeof data === "string") {
          data = jsonFromBase64(data);
        }
        window.slbConfig.rcPermissions.groupPermissionDocIds = res?.payload?.data?.groupPermissionDocIds || [];
        setRowsData(data);
        setLoading(false);
      }
    });
  }

  useEffect(() => {
    if (props.fromPopup) {
      if (dataColumns.length > 0) {
        setRowsData(props.rowsData);
        setLoading(false);
      }
    }
  }, [props.parentId, props.fields, dataColumns, props.fromPopup]);

  useEffect(() => {
    const newParams = { ...lazyParams };
    if (useGlobalFilter) {
      newParams.filters.fields = [];
    } else if (props.templateName === fieldsFilter?.template) {
      newParams.filters.fields = fieldsFilter?.fields;
    }
    if (Array.isArray(viewFields_metadata) && viewFields_metadata.length > 0) {
      newParams.metadataField = viewFields_metadata;
    }

    setLoading(true);
    if (lazyParams.rows) {
      if (!props.fromPopup) {
        getRecords(newParams);
      }
    }
    setIsPageChanged((isPageChanged) => {
      if (!isPageChanged) {
        setSelectedRows([]);
      }
      return false;
    });
    useGlobalFilter = false;
  }, [lazyParams, fieldsFilter]);

  useEffect(() => {
    setIsMounted(true);
    const onInit = props.onInit;
    if (typeof onInit == "function") {
      onInit({ refresh: refreshTable, setSelectedRows });
    }
    return () => {
      setIsMounted(false);
    };
  }, [lazyParams]);

  const onPage = (event) => {
    setIsPageChanged(true);
    setLazyParams((val) => {
      return {
        ...val,
        page: event.page,
        rows: event.rows,
        first: event.first,
        // filters: {
        //     ...event.filters,
        //     global: globalFilterValue
        // }
      };
    });
  };
  const filterTemplate = (options) => {
    // console.log(options)
    return (
      <InputText
        value={options.value}
        onKeyUp={(e) => {
          if (e.charCode === 13 || e.keyCode === 13) {
            handleFieldFilter(e, options.field);
          }
        }}
        autoComplete="off"
        id="dsf"
      />
    );

    // return <InputNumber value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} mode="currency" currency="USD" locale="en-US" />
  };

  const RenderAction = props._action.RenderAction;

  const isSelectable = dataColumns.find((s) => s.selectionMode) ? true : false;
  const dataKey = props.dataKey || "_id";
  return (
    <div className="datatable-doc-demo rc_doc_demo">
      <div className="card" style={{ height: "600px" }}>
        <DataTable
          lazy
          filterDisplay="menu"
          value={rowsData || []}
          paginator={props.paginator}
          first={lazyParams.first}
          totalRecords={totalRecords}
          onPage={onPage}
          className="p-datatable-customers"
          header={header}
          rows={lazyParams.rows}
          sortOrder={lazyParams.sortOrder}
          filters={lazyParams.filters}
          paginatorTemplate={RenderPagination}
          rowsPerPageOptions={props.rowsPerPageOptions}
          dataKey={dataKey}
          rowHover
          selection={selectedRows}
          selectionMode={isSelectable ? "checkbox" : false}
          onSelectionChange={(e) => {
            setSelectedRows(e.value);
          }}
          responsiveLayout="scroll"
          emptyMessage={
            loading ? (
              <div
                style={{ marginTop: "187.5px", marginBottom: "187.5px" }}
                className="table-records-loading rc_record_loading"
              >
                <ComponentLoader />
              </div>
            ) : (
              <>No Result Found</>
            )
          }
          currentPageReportTemplate="Showing {first} - {last} of {totalRecords} results"
          // loading={loading}
          scrollable
          scrollHeight="flex"
          rowClassName={props.rowClass}
          selectionPageOnly
          globalFilterFields={["fileName"]}
        >
          {/* <div className="tabletest123"> */}
          {loading
            ? null
            : dataColumns.map((item, index) => (
                <Column
                  // filterElement={item.filterable ? filterTemplate : null}
                  // filter ={item.filterable} filterPlaceholder={`Search by ${item.displayName}`}
                  style={{ width: item.width }}
                  key={index}
                  field={item.field}
                  selectionMode={
                    item.selectionMode ? item.selectionMode : false
                  }
                  header={
                    <span
                      dangerouslySetInnerHTML={{ __html: item.displayName }}
                    ></span>
                  }
                  body={(rowData, index) =>
                    RenderDataTemplate(
                      index,
                      item,
                      rowData,
                      props.setShowVersionListingPopup,
                      props.fromPopup
                    )
                  }
                ></Column>
              ))}
          {loading
            ? null
            : RenderAction && (
                <Column
                  style={{ width: props._action.width }}
                  className="action_column 444"
                  header={getConfiguredLabel(HomePage, actions)}
                  bodyStyle={{ overflow: "visible" }}
                  body={(row) => {
                    if (typeof RenderAction === "function") {
                      return RenderAction(row, actionColumn);
                    } else {
                      return null;
                    }
                  }}
                />
              )}
          {/* </div> */}
        </DataTable>
      </div>
    </div>
  );
};
export default Table;
